import { GRAPHQL_INT_MAXIMUM } from "@/modules/admin/better-doc/constants/better-doc-constants"

const POSITIVE_INTEGER_PATTERN = /^\d+$/

export const parseSessionIdParameter = (parameterValue: string | null) => {
  if (parameterValue === null || !POSITIVE_INTEGER_PATTERN.test(parameterValue)) {
    return null
  }

  const sessionId = Number(parameterValue)

  return sessionId > 0 && sessionId <= GRAPHQL_INT_MAXIMUM ? sessionId : null
}
